import Button from "components/Button";
import Text from "components/Text";
import styled from "styled-components";
import { colors } from "theme/colors";

export const RightContentWrapper = styled.div`
    margin: 0px 14px;
    background-color: #fff;
    padding: 20px 6px;
    border-radius: 24px;
    width: 100%;
    display: flex;
    flex-direction: column;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap:10px ;
  width:24%;
`
export const HeadingContentWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;  
    padding: 0rem 2rem 1rem 2rem;
    
`
export const Separator = styled.div`
   border: 2px;
`

export const SubHeadingWrapper = styled.div`
   background-color: #E5E4E2	;
   padding-top: 0.5rem;
   padding-bottom: 0.5rem;
   border-radius:8px;
   padding-left: 2rem;
`
export const GridRowContainer = styled.div`
   width:100%;
`
export const IconContainer = styled.div`
   display: flex;
   gap: 2rem;  
`
export const NotificationWrapper = styled.div`
   color: ${colors.white}  ;
`

export const GridTextWrapper = styled.div`
     display: flex;
     justify-content: space-between;
     padding-bottom: 1rem;
`
export const DeleteButton = styled(Button)`
    border-color: red;
    &:hover {
        box-shadow: 0px 4px 14px rgba(255, 0, 0, 0.1);
    }
    ${Text.Style} {
        color: red;
    }
`;
